import { getToken, hasExpiredToken } from "../api/token";

export async function authFetch(url, params, logout) {
  const token = getToken();

  if (!token) {
    // Usuario no logeado
    logout();
  } else {
    if (hasExpiredToken(token)) {
      // Token caducado
      logout();
    } else {
      const paramsTemp = {
        ...params,
        headers: {
          ...params?.headers,
          Authorization: `Bearer ${token}`,
        },
      };
      try {
        const response = await fetch(url, paramsTemp);
        // console.log(response, "34");
        if (!response.ok) {
          const errorData = await response.json().catch(() => null); // Try to parse response JSON

          // Handle different error response formats
          let errorMessage = `Unexpected error occurred (Status: ${response.status})`;
          if (errorData) {
            if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
              errorMessage = errorData.errors[0].message || errorMessage;
            }
          }

          throw {
            error: true,
            errorCode: response.status,
            message: errorMessage,
            originalError: errorData
          };
        }
        const result = await response.json();
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    }
  }
}
